"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const publicodes_1 = require("publicodes");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const contexts_1 = require("../contexts");
const RuleLink_1 = require("../RuleLink");
const Meta_1 = __importDefault(require("./Meta"));
function RuleHeader({ dottedName }) {
    const engine = react_1.useContext(contexts_1.EngineContext);
    if (!engine) {
        throw new Error('an engine should be provided in context');
    }
    const { title, rawNode: { description, question, icônes }, } = engine.getRule(dottedName);
    const displayTitle = icônes ? title + ' ' + icônes : title;
    return (jsx_runtime_1.jsxs(StyledHeader, Object.assign({ className: "ui__ plain card rule-header" }, { children: [jsx_runtime_1.jsx(Meta_1.default, { title: displayTitle, description: description || question }, void 0), jsx_runtime_1.jsx("ul", Object.assign({ className: "rule-header__breadcrumb" }, { children: publicodes_1.utils
                    .ruleParents(dottedName)
                    .reverse()
                    .map((parentDottedName) => (jsx_runtime_1.jsxs("li", { children: [jsx_runtime_1.jsx(RuleLink_1.RuleLinkWithContext, { dottedName: parentDottedName, displayIcon: true }, void 0), ' › '] }, parentDottedName))) }), void 0), ' ', jsx_runtime_1.jsx("h1", Object.assign({ className: "rule-header__title" }, { children: jsx_runtime_1.jsx(RuleLink_1.RuleLinkWithContext, { dottedName: dottedName, displayIcon: true, style: { textDecoration: 'none' } }, void 0) }), void 0)] }), void 0));
}
exports.default = RuleHeader;
const StyledHeader = styled_components_1.default.header `
	padding: 1rem;
	.rule-header__breadcrumb {
		margin: 0;
		padding: 0;
	}

	.rule-header__breadcrumb > li {
		display: inline;
		padding: 0;
	}

	.rule-header__title {
		margin: 0.6rem 0;
	}
`;
